<template>
  <div>
    <v-card
        elevation="0"
        class="ma-5"
    >
      <v-card-text>
        <v-row>
          <v-col cols="12">
            <h4 class="primary--text font-weight-medium">{{ $t('book/building:common.bill-address') }}</h4>

            <v-row>
              <v-col cols="12" sm="6" md="6">
                <v-select
                    outlined
                    :items="buildingOwnerOperator"
                    item-value="id"
                    item-text="name"
                    :hint="$t('book/building:common.copy-address')"
                    :label="$t('book/building:overview.form.labels.owner-operator')"
                    persistent-hint
                    :menu-props="{ bottom: true, offsetY: true}"
                    clearable
                    @input="copyCustomerAddress"
                    return-object
                />
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-select
                    outlined
                    :items="buildingOwnerOperator"
                    item-value="id"
                    item-text="name"
                    :hint="$t('book/building:common.copy-reg-number')"
                    :label="$t('book/building:overview.form.labels.owner-operator')"
                    persistent-hint
                    :menu-props="{ bottom: true, offsetY: true}"
                    clearable
                    @input="copyRegNumber"
                    return-object
                />
              </v-col>
            </v-row>

            <v-form ref="form">
              <v-text-field
                  outlined
                  v-model="building.billingPersonName"
                  :label="$t('common:name')"
                  clearable
                  tabindex="10"
              />

              <v-text-field
                  outlined
                  v-model="building.billingVatId"
                  :label="$t('book/building:common.reg-number')"
                  clearable
                  tabindex="11"
              />

              <v-text-field
                  outlined
                  v-model="building.billing_street"
                  :label="$t('common:address')"
                  clearable
                  tabindex="12"
              />
              <v-row>
                <v-col class="py-0">

                  <v-text-field
                      outlined
                      v-model="building.billing_zip"
                      :label="$t('common:zip')"
                      clearable
                      tabindex="13"
                  />
                </v-col>
                <v-col class="py-0">

                  <v-text-field
                      outlined
                      v-model="building.billing_city"
                      :label="$t('common:city')"
                      clearable
                      tabindex="14"
                  />
                </v-col>
              </v-row>
            </v-form>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions class="px-5 pb-5">
        <BaseButton
            color="primary"
            :btn-text="$t('buttons:save-changes')"
            @clickedButton="saveBuilding"
        />
      </v-card-actions>
    </v-card>

    <!-- TODO uncomment and finish when invoices are implemented -->
    <!-- <v-row class="pa-5">
      <v-col class="px-3">
        <v-row no-gutters align="center">
          <h5 class="greyBold--text font-weight-bold mb-0">Deine Rechnungen</h5>
          <v-btn class="ml-2" icon @click="cardView = !cardView">
            <v-icon>list_alt</v-icon>
          </v-btn>
        </v-row>

      </v-col>
      <v-col cols="12" class="pt-0" v-show="!cardView">
        TODO add datatable with invoices data
      </v-col>
    </v-row>
    <v-row v-show="cardView" class="px-5">
        TODO add itemCards with invoices data
        TODO add drag and drop component for uploading invoices
    </v-row> -->
  </div>
</template>

<script>
import {ruleRequired} from "@/modules/core/services/rules";
import BaseButton from "@/modules/core/components/Base/BaseButton";

import Building from "@/modules/book/data/building";
import CustomerService from "@/modules/core/services/customer-service";

export default {
  name: 'BuildingFinancesTab',
  components: {
    BaseButton
  },
  data() {
    return {
      building: new Building(),
      cardView: true,
      buildingOwnerOperator: [],
    }
  },
  methods: {
    ruleRequired,
    getFormValidation() {
      return this.$refs.form.validate();
    },
    saveBuilding() {
      this.$emit('save', this.building, this.$refs.form.validate())
    },
    addCustomerToSelection(customerId) {
      if (customerId) {
        CustomerService.readAddress(customerId,
            (res) => {
              if (!this.buildingOwnerOperator.some(customer => customer.id === res.data.id)) {
                this.buildingOwnerOperator.push(res.data);
              }
              let notNeededCustomers = this.buildingOwnerOperator.filter(customer => customer.id !== this.building.operator && customer.id !== this.building.owner);

              let objectIndexToRemove = this.buildingOwnerOperator.indexOf(notNeededCustomers[0]);
              if(objectIndexToRemove !== -1) {
                this.buildingOwnerOperator.splice(objectIndexToRemove, 1);
              }
            }
        )
      }
    },

    /**
     * Copys address and name from selected customer.
     *
     * @param item customer to copy data from
     */
    copyCustomerAddress(item) {
      if (item) {
        this.building.billingPersonName = item.name;
        this.building.billing_street = item.street;
        this.building.billing_zip = item.zip;
        this.building.billing_city = item.city;
        this.building.billingVatId = item.vatId;
      }
    },

    /**
     * Copys registration number of customer to building billing uid
     *
     * @param item customer to copy reg number from
     */
    copyRegNumber(item) {
      if (item) {
        this.building.billingVatId = item.vatId;
      }
    }
  }
}
</script>
